import { tv } from 'tailwind-variants'

export const assistantContainerVariants = tv({
  slots: {
    container: 'flex flex-col h-full bg-white',
    header: 'flex flex-row p-mili justify-between mb-1 items-center',
    headerClient: 'flex flex-row space-x-mili',
    headerDescription: 'flex flex-col',
    assistant: 'flex-1 relative overflow-y-auto',
    clientName: 'font-bold',
    phoneNumber: 'text-sub'
  }
})
